import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class ViewSingleTicketProduct extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div>
                {/*<h3 className="mb0 mt40">9. 여행상품 삭제 API </h3>*/}
                <h3 className="mb0 mt40">단일 조회</h3>
                <div className="blog-post-meta">
                    <span className="s-post">상품 ID(travelProductId)로 등록된 상품을 조회합니다.</span>
                    <h3 className="request-method">
                        <span className="label label-success">GET</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/tickets/{'{travelProductId}'}</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td>data</td>
                            <td>TravelDto</td>
                            <td>응답 데이터 (요청 값을 참조하시기 바랍니다.)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "SUCCESS",
    "data": {
        "sellerProductId": "string",
        "name": "Jenny_Test_5",
        "adultOnly": true,
        "subordinateIds": [
            "string"
        ],
        "searchTags": [
            "test1"
        ],
        "displayKeyword": "test1",
        "images": [
            {
                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_345855cf-a8a4-4dae-88aa-0797d665385d.jpg",
                "sellerUrlMethod": "GET",
                "representative": true,
                "sellerImageCategory": "1234",
                "imageGroup": "BASIC",
                "description": "image 1 description",
                "seq": 0
            }
        ],
        "trafficInfo": "string",
        "publicTransportInfo": "string",
        "inventoryType":"PERIOD",
        "nearbyLandmarks": null,
        "locations": null,
        "contents": [
            {
                "title": "product content title 2",
                "type": "Product-Content",
                "content": null,
                "format": "IMAGE",
                "sellerUrl": "http://image13.coupangcdn.com/image/bannerunit/bannerunit_345855cf-a8a4-4dae-88aa-0797d665385d.jpg",
                "sellerUrlMethod": "GET",
                "seq": 0
            }
        ],
        "features": [
            {
                "featureId": "TYPE",
                "featureValues": [
                    "WIFI",
                    "CAMERA"
                ],
                "description": ""
            }
        ],
        "reservationNotifications": null,
        "contacts": [
            {
                "contactType": "PHONE",
                "contactUseType": "REPRESENTATIVE",
                "contact": "010-0000-0000"
            }
        ],
        "cancelPolicy": {
            "notice": "string",
            "cancelType": "AUTO",
            "cancelPeriodType": "BEFORE_USE",
            "cancelMarkType": "NOT_CANCELED",
            "refundOnBusinessDay": true,
            "refundUnusedTicket": true,
            "refundRates": []
        },
        "introduction": "introduction test",
        "notice": "string",
        "benefits": [
            "string"
        ],
        "hotelInfo": null,
        "insuranceInfo": null,
        "inclusionNotice": "string",
        "exclusionNotice": "string",
        "usageNotice": "test",
        "reservationGuide": null,
        "additionalInfoPrompt": "string",
        "maxPurchaseQuantity": 0,
        "csContactInfo": "string",
        "taxType": "FREE",
        "instantBooking": true,
        "estimatedBookingDuration": 0,
        "extension": null,
        "travelProductId": 527852958679826432,
        "productId": 10000000000680,
        "vendorItemPackageId": 30000000000460,
        "productDetailType": "READY_TO_TRIP",
        "travelType": "OVERSEAS",
        "displayCategoryCode": 108804,
        "interlockingChannelType": null,
        "vendorId": "A00100622",
        "saleStatus": "ON_SALE",
        "qcStatus": "COMPLETE_APPROVAL",
        "displayChannels": null,
        "userAgreements": null,
        "reservationRequired": false,
        "errors": null,
        "travelItems": [
            {
                "sellerTravelItemId": "string",
                "name": "test item 2",
                "description": "string",
                "seq": 0,
                "features": [
                    {
                        "featureId": "OFFERING_SERVICE",
                        "featureValues": [
                            "NO_CHARGE_CALL",
                            "UNLIMITED_USE"
                        ],
                        "description": ""
                    }
                ],
                "taxType": "FREE",
                "onSale": true,
                "rates": [
                    {
                        "sellerRateId": "",
                        "rateType": "BASIC",
                        "priceType": "COUPANG_PRICE",
                        "price": 0,
                        "representative": true,
                        "saleStartedAt": "2019-10-01 23:59:59",
                        "saleEndedAt": "2019-12-31 23:59:59",
                        "maxPurchaseQtyPerPerson": 0,
                        "maxPurchaseQtyPeriod": 0,
                        "seq": 0
                    }
                ],
                "usePeriod": {
                    "usePeriodName": "string",
                    "useStartedAt": "2019-12-01 23:59:59",
                    "useEndedAt": "2020-12-31 23:59:59"
                },
                "travelItemId": 527852958730158080,
                "deleted": false
            }
        ],
        "createdBy": "172.29.32.116",
        "createdAt": "2019-12-27 23:19:15",
        "modifiedBy": "SYSTEM",
        "modifiedAt": "2019-12-27 23:19:21"
    }
}
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TicketAPIContent/TicketProductAPI/ViewSingleTicketProduct.jsx